import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { SearchService } from 'src/app/shared/services/search.service';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { Router, RouteConfigLoadStart, ResolveStart, RouteConfigLoadEnd, ResolveEnd } from '@angular/router';
import { FeatureService } from 'src/app/service/feature.service';
@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    animations: [SharedAnimations]
  })
export class AuthLayoutComponent implements OnInit {
  moduleLoading: boolean;
  constructor(
    public featureService: FeatureService,
    public navService: NavigationService,
    public searchService: SearchService,
    private router: Router
  ) { }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if(event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        this.moduleLoading = true;
      }
      if(event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.moduleLoading = false;
      }
    });
  }

}




// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-auth-layout',
//   templateUrl: './auth-layout.component.html',
//   styleUrls: ['./auth-layout.component.scss']
// })
// export class AuthLayoutComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }
